<template>
  <div class="sso-callback">
    로그인 처리 중...
  </div>
</template>

<script setup lang='ts'>
import { useRouter } from 'vue-router'
import { setAuthToken } from '@/utils/auth'

const router = useRouter()

// 백엔드가 토큰/에러를 URL fragment(#)로 전달한다.
const raw = (window.location.hash || '').replace(/^#/, '')
const params = new URLSearchParams(raw)

const ssoError = params.get('ssoError')
if (ssoError) {
  // LoginPage가 에러를 표시하도록 query로 전달
  router.replace({ name: 'Login', query: { ssoError } })
} else {
  const accessToken = params.get('accessToken')
  const refreshToken = params.get('refreshToken')
  if (accessToken) {
    setAuthToken({ accessToken, refreshToken })
    router.replace({ name: 'Board' })
  } else {
    router.replace({ name: 'Login' })
  }
}
</script>

<style lang="scss" scoped>
.sso-callback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  font-size: 16px;
  color: #666;
}
</style>
